/**
 *
 * Removes listener from element
 * @param {Element} node
 * @param {string} eventName
 * @param {function} listener
 * @param {boolean} shouldCapture
 */
export function removeEvent(
    node: any,
    eventName: string,
    listener: (event: any) => void,
    shouldCapture?: boolean,
) {
    if (node.detachEvent) {
        node.detachEvent(`on${eventName}`, listener);
    } else {
        node.removeEventListener(eventName, listener, shouldCapture);
    }
}
